import { showDocumentModalGetters, showHowItWorksModalGetters, bookACallModalGetters } from './routines'

export default {
  [showDocumentModalGetters.SHOW_DOCUMENT_MODAL]: state => state.showDocumentModal,
  [showHowItWorksModalGetters.SHOW_HOW_IT_WORKS_MODAL]: state => state.showHowItWorksModal,
  [bookACallModalGetters.BOOK_A_CALL_MODAL_SEEN]: state => state.bookACallModalSeen
}
